import EN from "./en";
import FR from "./fr";
import AR from "./ar";

const resources = {
	en: EN,
	fr: FR,
	ar: AR,
	"en-gb": EN,
};

export default resources;
